import React, { Component } from 'react'
import styled, { injectGlobal } from 'styled-components'
import Header from './Header'
import Modal from './Modal'
import TWFMap from './TWFMap'

injectGlobal`
  * {
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica,
      Arial, sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: #3a3b3c;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html,
  body,
  #root,
  .App {
    width: 100%;
    height: 100%;
    margin: 0;
  }

  .App {
    position: relative;
  }
`

const AppContainer = styled.section`
  width: 100vw;
  height: 100vh;
  position: relative;
`

export default class App extends Component {
  state = { showModal: false }
  render() {
    return (
      <AppContainer>
        <Header openModal={this.handleOpenModal} />
        <TWFMap />
        {this.state.showModal && <Modal handleClose={this.handleCloseModal} />}
      </AppContainer>
    )
  }

  handleCloseModal = () => {
    this.setState({
      showModal: false,
    })
  }

  handleOpenModal = () => {
    this.setState({
      showModal: true,
    })
  }
}



// WEBPACK FOOTER //
// ./src/App.js